module.exports = __webpack_public_path__ + "static/media/cmob9.9e5e1004.svg";